import React, { useState } from "react";
import {
    Button, Modal, ModalHeader, ModalBody,
    ModalFooter, Table
} from "reactstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";



toast.configure();

const DraftUnlabeledData = ({ showModal, setShowModel, _makeDocDraft }) => {
    const confirmation = () => {
        showModal = true
        _makeDocDraft()
    }

    return (
        <>
            <Modal isOpen={showModal}
                backdrop="static">
                <ModalHeader>
                </ModalHeader>
                <ModalBody>
                    <label>
                        <h4>
                        You are about to leave this loan. Your documents will not be indexed.<br/>
                        Do you want to continue?
                        </h4>
                    </label>
                </ModalBody>
                <ModalFooter>
                    <Button color="link" onClick={() => confirmation()} className="cancel-btn">
                        Yes
                    </Button>
                    <Button color="secondary" onClick={() => setShowModel()} >
                        No
                    </Button>
                </ModalFooter>

            </Modal>
        </>
    );
};

export default DraftUnlabeledData;
